import authRoutes from './http/auth-routes.js';
import moment from 'moment';

const extractTimestamp = (timestamp) => {
    return timestamp && timestamp.date ? timestamp.date : timestamp;
};

export const datePassed = (date) => {
    const now = moment.utc().local();
    const checkDate = moment.utc(date).local();

    return now > checkDate;
};

export const timeFormat = (timestamp, type = 'none') => {
    if (!timestamp) {
        return '';
    }

    timestamp = extractTimestamp(timestamp);

    if (type === 'chat-window') {
        const now = moment.utc().local().format('LT');
        const time = moment.utc(timestamp).local().format('LT');

        return time === now ? 'Just now' : time;
    }

    return moment.utc(timestamp).local().format('LT');
};

export const conversationTimeFormat = (timestamp) => {
    timestamp = extractTimestamp(timestamp);

    return moment.utc(timestamp).local().format('LT');
};

export const dateFormat = (date) => {
    date = extractTimestamp(date);

    return moment.utc(date).local().format('MMMM Do YYYY');
};

export const isAuthRoute = (route) => {
  return authRoutes.includes(route.name);
};

export const clone = (value) => JSON.parse(JSON.stringify(value));

function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export const validateFormData = (data, schema) => {
    let valid = true;
    let errors = {};

    Object.keys(schema).forEach(key => {
        const rules = schema[key].split('|');

        for (let rule of rules) {
            switch (rule) {
                case 'required':
                    if (!errors[key] && !data[key]) {
                        valid = false;
                        errors[key] = 'Field is required';
                    }
                    break;
                case 'email':
                    if (!errors[key] && !isValidEmail(data[key])) {
                        valid = false;
                        errors[key] = 'Not a valid email address';
                    }
                    break;
                default:
                    break;
            }
        }
    });

    return { valid, errors, first: !valid ? errors[Object.keys(errors)[0]] : '' };
};

export const cookies = {
    get: (name) => {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },
    set: (name,value,days) => {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    },
    delete: (name) => {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
};

export const Feature = {
    ENABLED: 'enabled',
    DISABLED: 'disabled',
};
